var _path;
import * as React from "react";
import { SvgIcon } from '@mui/material';
const SvgPinterest = props => /*#__PURE__*/React.createElement(SvgIcon, props, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.375 10.5c0 2.212-.777 4.24-2.19 5.707-1.324 1.377-3.123 2.167-4.935 2.167-1.448 0-2.51-.392-3.27-.873l-.885 3.756a1.124 1.124 0 11-2.19-.516l3-12.75a1.124 1.124 0 112.19.516l-1.542 6.556c.327.392 1.118 1.061 2.697 1.061 2.396 0 4.875-2.105 4.875-5.625a6.375 6.375 0 10-11.898 3.188 1.125 1.125 0 01-1.947 1.125 8.625 8.625 0 1116.095-4.313z"
})));
export default SvgPinterest;